module.exports = __webpack_public_path__ + "static/img/peopleBg2.925a699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/peopleBg2.png
// module id = 9Ed9
// module chunks = 1